module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-03-c6bea0d5ec0d988f4d1c7918b7531686.jpg";